import React from 'react';
import ReactDOM from 'react-dom';
import ReactPlayer from 'react-player';

const DEFAULT_LANDSCAPE_PLAYER_SIZE = { width: 320, height: 180 };
const DEFAULT_PORTRAIT_PLAYER_SIZE = { width: 180, height: 320 };

let currentPlayerCleanup = null;
let clickOutsideHandler = null;

export function showVideoPlayer(videoUrl, clickedElement, onClose) {
    if (!videoUrl || !clickedElement) return null;

    if (currentPlayerCleanup) {
        currentPlayerCleanup();
        currentPlayerCleanup = null;
    }

    const isYoutubeShort = videoUrl.includes('youtube.com/shorts/');
    const playerSize = isYoutubeShort
        ? DEFAULT_PORTRAIT_PLAYER_SIZE
        : DEFAULT_LANDSCAPE_PLAYER_SIZE;

    const rect = clickedElement.getBoundingClientRect();

    const playerElement = document.createElement('div');
    playerElement.className = 'floating-video-player';
    playerElement.style.position = 'absolute';
    playerElement.style.top = `${rect.top + window.pageYOffset}px`;
    playerElement.style.right = `${window.innerWidth - rect.left}px`;
    playerElement.style.transformOrigin = 'top right';
    playerElement.style.zIndex = '1000';

    const cleanup = () => {
        if (document.body && document.body.contains(playerElement)) {
            document.body.removeChild(playerElement);
        }
        if (clickOutsideHandler) {
            document.removeEventListener('click', clickOutsideHandler);
            clickOutsideHandler = null;
        }
        currentPlayerCleanup = null;
        onClose && onClose();
    };

    clickOutsideHandler = event => {
        if (playerElement && !playerElement.contains(event.target)) {
            cleanup();
        }
    };

    setTimeout(() => {
        document.addEventListener('click', clickOutsideHandler);
    }, 100);

    ReactDOM.render(
        <React.Fragment>
            <ReactPlayer
                className="video-player"
                url={videoUrl}
                width={playerSize.width}
                height={playerSize.height}
                playing={true}
                loop
                muted
                controls={false}
            />
        </React.Fragment>,
        playerElement
    );

    document.body.appendChild(playerElement);

    currentPlayerCleanup = cleanup;

    return cleanup;
}

export function showVideoPlayerForCircuitBuilder(
    videoUrl,
    clickedElement,
    onClose
) {
    if (!videoUrl || !clickedElement) return null;

    if (currentPlayerCleanup) {
        currentPlayerCleanup();
        currentPlayerCleanup = null;
    }

    const isYoutubeShort = videoUrl.includes('youtube.com/shorts/');
    const playerSize = isYoutubeShort
        ? DEFAULT_PORTRAIT_PLAYER_SIZE
        : DEFAULT_LANDSCAPE_PLAYER_SIZE;

    let playerContainer = document.getElementById(
        'floating-video-player-container'
    );
    if (!playerContainer) {
        playerContainer = document.createElement('div');
        playerContainer.id = 'floating-video-player-container';
        document.body.appendChild(playerContainer);
    }

    const rect = clickedElement.getBoundingClientRect();

    let playerElementTop = rect.top;

    if (playerElementTop + playerSize.height > window.innerHeight) {
        playerElementTop = window.innerHeight - playerSize.height - 100;
    }

    const playerElement = document.createElement('div');
    playerElement.className = 'floating-video-player';
    playerElement.style.position = 'fixed';
    playerElement.style.top = `${playerElementTop}px`;
    playerElement.style.right = `480px`;
    playerElement.style.transformOrigin = 'top right';
    playerElement.style.zIndex = '1300';

    const cleanup = () => {
        if (playerContainer && playerContainer.contains(playerElement)) {
            playerContainer.removeChild(playerElement);
        }
        if (clickOutsideHandler) {
            document.removeEventListener('click', clickOutsideHandler);
            clickOutsideHandler = null;
        }
        currentPlayerCleanup = null;
        onClose && onClose();
    };

    clickOutsideHandler = event => {
        if (playerElement && !playerElement.contains(event.target)) {
            cleanup();
        }
    };

    setTimeout(() => {
        document.addEventListener('click', clickOutsideHandler);
    }, 100);

    ReactDOM.render(
        <React.Fragment>
            <ReactPlayer
                className="video-player"
                url={videoUrl}
                width={playerSize.width}
                height={playerSize.height}
                playing={true}
                loop
                muted
                controls={false}
            />
        </React.Fragment>,
        playerElement
    );

    playerContainer.appendChild(playerElement);

    currentPlayerCleanup = cleanup;

    return cleanup;
}

export function closeVideoPlayer() {
    if (currentPlayerCleanup) {
        currentPlayerCleanup();
        currentPlayerCleanup = null;
    }
    if (clickOutsideHandler) {
        document.removeEventListener('click', clickOutsideHandler);
        clickOutsideHandler = null;
    }
}
